import React from "react";
import AdsList from "../components/AdsList";

function AdList(props) {
  return (
    <div className="container">
      <AdsList />
    </div>
  );
}

export default AdList;
